export const CONFIG = {
	/**
	 * htmlのlang属性
	 */
	get lang(){
		return $('html').attr('lang') || 'ja';
	},

	/**
	 * PC時のサイトの最小幅
	 */
	get siteWidth() { return 1240 },

	/**
	 * ブレイクポイント
	 */
	get breakpoint() { return 767 },

	/**
	 * グロナビとかが追従するときのスクロール値の調整用数値
	 */
	scrollOffset: {
		/**
		 * PC時
		 */
		get pc(){
			return ($('.gHeader').outerHeight() || 0) + 20
		},

		/**
		 * SP時
		 */
		get sp() {
			return ($('.gHeader').outerHeight() || 0) + 20
		}
	},

	/**
	 * スムーススクロール用の設定
	 */
	scrollAnim: {
		/**
		 * スムーススクロールのスピード
		 */
		get speed(){
			return 1000
		},

		/**
		 * スムーススクロールのイージング
		 */
		get easing(){
			return ['swing', 'linear'][0]
		},
	}
}
